module.exports = __webpack_public_path__ + "images/index/default.2fcb3bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.png
// module id = jY2U
// module chunks = 21